import React from 'react';
import StatisticsSummary from '../components/StatisticsSummary';
import SessionAggregations from '../components/SessionAggregations';

function StatisticsPage() {
    return (
        <div className="max-w-7xl mx-auto px-2 sm:px-4">
            <div className="space-y-4">
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6">Statistics</h1>
                <div className="grid grid-cols-1 gap-3 sm:gap-4">
                    <div className="bg-[#faf8f5] dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-3 sm:p-6">
                        <StatisticsSummary />
                    </div>
                    <div className="bg-[#faf8f5] dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-3 sm:p-6">
                        <SessionAggregations />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StatisticsPage; 